export default "<router-outlet class=\"logo_fundo\"></router-outlet>\n";